import React from 'react';
import { useAvaliableWidgetRecord } from '../../../../hooks/useAvaliableWidgetRecord';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { TYPE_OFFLINE } from '../../../../constants/common';

import Icons from '../../../Icons';

import './style.scss';

const EpisodeRecordStatus = ({episode = null, displayRecord = false, children}) => {
    const $locale = useLocaleContext();
    const hasEpisodeRecord = useAvaliableWidgetRecord(episode);

    if (!episode || !hasEpisodeRecord || !displayRecord) {
        return children;
    }

    return (
        <div
            className={`episode-record-status episode-record-status--${episode.displayRecord && episode.participationType !== TYPE_OFFLINE ? 'has' : 'not'}`}>
            {
                episode.displayRecord && <Icons name="play" />
            }
            <span>
                {$locale.get(`episode.record.${episode.displayRecord && episode.participationType !== TYPE_OFFLINE ? 'has' : 'not'}`)}
            </span>
        </div>
    )
};

export default EpisodeRecordStatus;
